import React from "react";
/*import { graphql } from "react-apollo";
import gql from "graphql-tag";*/
import gql from "graphql-tag";
import { Query } from "react-apollo";
import moment from "moment-timezone";
import loader from "../../img/loading.svg";
import Button from "./Button";
import styled from "styled-components";

const GET_NEXT_RDV = gql`
  query getNextAvailableRdv(
    $rdvTypeId: ID!
    $rdvTypeDuration: Int!
    $doctorId: ID!
    $weekId: ID!
    $baseDuration: Int!
    $daysAhead: Int!
    $minTime: Int!
    $maxTime: Int!
  ) {
    getNextAvailableRdv(
      rdvTypeId: $rdvTypeId
      rdvTypeDuration: $rdvTypeDuration
      doctorId: $doctorId
      weekId: $weekId
      baseDuration: $baseDuration
      daysAhead: $daysAhead
      minTime: $minTime
      maxTime: $maxTime
    ) {
      date
    }
  }
`;

const Date = styled.p`
  font-size: 1em;
  font-weight: bolder;
  color: #000;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 1.2em;
`;
const DateText = styled.p`color: #333;`;
const DateTextError = styled.p`color: red;`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

class NextRdvNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, autoCloseOn: false };
  }
  /*static getDerivedStateFromProps(nextProps, prevState) {

    if (nextProps.autoClose === false && prevState.autoCloseOn === true) {
      return { autoCloseOn: false };
    }
    if (nextProps.updated && prevState.updated) {
      return { updated: false, autoCloseOn: false };
    }
    return null;
  }*/

  updateToast = () => {
    this.setState({ autoCloseOn: true }, () => this.props.updateToast());
  };

  render() {
    const {
      doctorId,
      daysAhead,
      baseDuration,
      weekId,
      rdvTypeId,
      rdvTypeDuration,
      minTime,
      maxTime
    } = this.props;
    return (
      <div>
        <Query
          query={GET_NEXT_RDV}
          variables={{
            doctorId,
            daysAhead,
            baseDuration,
            weekId,
            rdvTypeId,
            rdvTypeDuration,
            minTime,
            maxTime
          }}
        >
          {({ loading, error, data }) => {
            if (loading) {
              return (
                <div>
                  <DateText>
                    Le prochain rendez-vous disponible est le :
                  </DateText>
                  <figure className="image is-58x58" style={{ margin: "auto" }}>
                    <img alt="loading" src={loader} />
                  </figure>
                </div>
              );
            }
            if (error) {
              console.error(error);
              return (
                <div>
                  <DateText>
                    Le prochain rendez-vous disponible est le :
                  </DateText>
                  <DateTextError>Une erreur c'est produite!</DateTextError>
                </div>
              );
            }

            if (!this.state.autoCloseOn) {
              this.updateToast();
            }
            return (
              <div>
                <DateText>Le prochain rendez-vous disponible est le :</DateText>
                <Date>
                  {data.getNextAvailableRdv === null ||
                  data.getNextAvailableRdv.date === "nothing" ? (
                    "Aucune date n'a été trouvée."
                  ) : (
                    moment(data.getNextAvailableRdv.date).format(
                      "DD MMMM YYYY [à] HH:mm"
                    )
                  )}
                </Date>
                <ButtonContainer>
                  <Button text="Retour" onClick={this.props.toggleModal} />
                  {data.getNextAvailableRdv === null ||
                  data.getNextAvailableRdv.date === "nothing" ? null : (
                    <Button
                      color="#00893D"
                      text="Prendre"
                      onClick={() =>
                        this.props.modalCallback(
                          moment(data.getNextAvailableRdv.date)
                        )}
                    />
                  )}
                </ButtonContainer>
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}

export default /*graphql(CREATE_COLOR_MUTATION, {
  name: "createColorMutation"
})*/ NextRdvNotification;



// WEBPACK FOOTER //
// ./src/components/utilities/NextRdvNotification.js